/**
 * Minimal browser-friendly mock of Node's os module.
 */

const platformValue = typeof navigator !== 'undefined'
  ? (navigator as any).userAgentData?.platform || navigator.platform || 'browser'
  : 'browser';

export const platform = (): string => platformValue.toLowerCase();
export const type = (): string => 'BrowserOS';
export const release = (): string => '0.0.0';
export const arch = (): string => (typeof navigator !== 'undefined' && navigator.hardwareConcurrency ? 'wasm32' : 'x64');
export const homedir = (): string => '/';
export const tmpdir = (): string => '/tmp';
export const freemem = (): number => 0;
export const totalmem = (): number => 0;
export const cpus = (): Array<{ model: string; speed: number }> => [];
export const endianness = (): 'BE' | 'LE' => 'LE';
export const userInfo = (): { username: string; homedir: string } => ({ username: 'browser', homedir: homedir() });
export const EOL = '\n';

export default {
  platform,
  type,
  release,
  arch,
  homedir,
  tmpdir,
  freemem,
  totalmem,
  cpus,
  endianness,
  userInfo,
  EOL,
};
